// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
import { Action, createAction, props } from '@ngrx/store';

export enum UserListActionTypes {
    Update = '[UserList] UPDATE'
}

export enum ProjectListActionTypes {
    UpdateProjects = '[ProjectList] UPDATE_PROJECTS'
}

export class Update implements Action {
    readonly type = UserListActionTypes.Update

    constructor(public payload: string) {

    }
}

export class UpdateProjects implements Action {
    readonly type = ProjectListActionTypes.UpdateProjects

    constructor(public payload: string) {

    }
}

export type UserListActions = Update
export type ProjectListActions = UpdateProjects

export const InitializeCoreData = createAction(
    '[CoreAppFlow] Initialize Core Data',
    props<{payload: any}>()
)

export const IdentityFailure = createAction(
    '[Identity] Identity validation failure',
    props<{payload: undefined}>()
)

export const IdentitySuccess = createAction(
    '[Identity] Identity validation success',
    props<{payload: any}>()
)
